import { useSelector } from "react-redux";
import { State } from "../../app/store";

export default function useHideTimeFromExercises(): boolean {
  return useSelector((state: State) => state.config.configuration.hideTimeFromExercises === true);
}
